module.exports = __webpack_public_path__ + "img/close-white.b06254ae.svg";